import Nav from '../Nav/Nav'
import Footer from '../Footer/Footer'
import './Layout.css'

export default function Layout(props) {
  return (
    <div className='layout'>
      <Nav className='navigation' />

      <div className='layout-body'>
        <div className="layout-children">
          {props.children}
        </div>
        {/* <Footer className='foot' /> */}
      </div>
    </div>
  )
}
